import eaiws = egr.wcf.eaiws;
import utils = egr.wcf.utils;

const networkErrorQueue: Array<utils.async.AjaxErrorInfo> = [];

export function retryNetworkRequests(): void {
    networkErrorQueue.forEach((error: utils.async.AjaxErrorInfo): void => {
        error.retry();
    });
    networkErrorQueue.length = 0;
}

export type SoapError = utils.async.AjaxErrorInfo & { responseError: eaiws.SoapError };

export interface AjaxErrorHandlerCallbacks {
    networkError: VoidFunction;
    soapError: (error: SoapError) => void;
    eaiwsSessionExpired: (error: SoapError) => void;
}

function isSoapError(error: utils.async.AjaxErrorInfo): error is SoapError {
    return error.responseError instanceof eaiws.SoapError;
}

export class IgnoreAjaxErrorHandlerError extends utils.CustomError {
    constructor(message?: string, public xhr?: XMLHttpRequest) {
        super(message);

        Object.setPrototypeOf(this, IgnoreAjaxErrorHandlerError.prototype);
    }
}

export type AjaxErrorHandler = (error: Error | string, xhr: XMLHttpRequest, response: unknown) => Error;
export function ignoreAjaxErrorHandlerMessageCallback(error: Error | string, xhr: XMLHttpRequest, response: unknown): Error {
    const message: string  = error instanceof Error ? error.message : error.toString();
    return new IgnoreAjaxErrorHandlerError(message, xhr);
}

export function registerAjaxErrorHandler(callbacks: AjaxErrorHandlerCallbacks): void {
    if (egr.wcf.utils.async.ajaxErrorHandler != null) {
        throw new Error('An global ajax error handler has already been registered');
    }

    // connect global ajax error handler
    egr.wcf.utils.async.ajaxErrorHandler = (error: utils.async.AjaxErrorInfo): void => {
        if (error.responseError instanceof IgnoreAjaxErrorHandlerError) {
            error.reject();
        } else if (isSoapError(error)) {
            // Note: double checking of `isinstance` vs another function argument (ts type guard)
            if (error.responseError.message.indexOf('unknown session:') === 0) {
                callbacks.eaiwsSessionExpired(error);
            } else {
                callbacks.soapError(error);
            }
        } else if (error.status === 0) { // Network error
            networkErrorQueue.push(error);
            callbacks.networkError();
        } else {
            error.reject();
        }
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/utils/AjaxErrorHandler.ts